import { User } from '../reducers/reports'
import { RootState } from '../store'
import { createSelector } from '@reduxjs/toolkit'

export const usersSelector = (state: RootState) => {
  const { users } = state

  return users
}

export const driversAndAssistantsSelector = createSelector(
  [(state: RootState) => state.users.users],
  (users) => {
    const withoutDriver: User = {
      id: 99,
      active: true,
      name: 'Без водителя',
      login: '',
      email: '',
      phone: '',
      phone2: '',
      registration: '',
      role: 'driver',
      avatar: [],
    }

    // Create a new array with the existing users plus the withoutDriver
    const allUsers = [withoutDriver, ...users]

    return allUsers.filter(
      (user) => user.role === 'driver' || user.role === 'owner'
    )
  }
)

export const driversSelector = (state: RootState) => {
  const { users } = state

  return users.users.filter((user) => user.role === 'driver')
}
